import { render, staticRenderFns } from "./Creditfreelist.vue?vue&type=template&id=5502fe42"
import script from "./Creditfreelist.vue?vue&type=script&lang=js"
export * from "./Creditfreelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports